import { DocumentNode } from 'graphql'
import { computed, makeObservable } from 'mobx'

import {
  DeleteDeliveryVehicleTypesDocument,
  GetDeliveryVehicleTypesDocument,
  ListenToDeliveryVehicleTypesDocument,
  SaveDeliveryVehicleTypesDocument,
} from '~/client/graph/operations/generated/DeliveryVehicleTypes.generated'

import CommonDeliveryAttributeDto from '../../types/CommonDeliveryAttributeDto'
import EventsStore from '../EventStore/Events.store'
import CommonDeliveryAttributesStore from './CommonDeliveryAttributes.store'
import GraphExecutorStore from './GraphExecutor.store'

export default class DeliveryVehicleTypesStore extends CommonDeliveryAttributesStore {
  protected readonly collectionKey: string = 'deliveryVehicleTypes'

  protected readonly loadQuery: DocumentNode = GetDeliveryVehicleTypesDocument
  protected readonly subscriptionQuery: DocumentNode =
    ListenToDeliveryVehicleTypesDocument
  protected readonly saveMutation: DocumentNode =
    SaveDeliveryVehicleTypesDocument
  protected readonly deleteMutation: DocumentNode =
    DeleteDeliveryVehicleTypesDocument

  public constructor(
    eventsStore: EventsStore,
    graphExecutorStore: GraphExecutorStore,
  ) {
    super(eventsStore, graphExecutorStore)

    makeObservable(this)
  }

  @computed
  public get list(): CommonDeliveryAttributeDto[] {
    return this.listWithoutDeletedData.filter(
      entry => !entry.isFromConcreteDirect,
    )
  }

  @computed
  public get listWithoutDeletedData(): CommonDeliveryAttributeDto[] {
    return this.allItems.filter(entry => !entry.isDeleted)
  }

  public get byId(): Map<string, CommonDeliveryAttributeDto> {
    return this.eventsStore.appState.deliveryVehicleTypes
  }

  @computed
  private get allItems(): CommonDeliveryAttributeDto[] {
    return Array.from(this.byId.values())
  }
}
